import {Color} from '@benchling/nucleus-ui';
import {Alert} from '@mantine/core';
import React from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {MismatchStatus} from './useSchemaMismatchDetection';
import type {SchemaMismatchResult} from './useSchemaMismatchDetection';

interface SchemaMismatchAlertProps {
  mismatchResult: SchemaMismatchResult;
  autoSwitchMessage?: string | null;
}

export default function SchemaMismatchAlert({
  mismatchResult,
  autoSwitchMessage,
}: SchemaMismatchAlertProps): JSX.Element | null {
  if (mismatchResult.status === MismatchStatus.OK && !autoSwitchMessage) {
    return null;
  }

  const isBlocked = mismatchResult.status === MismatchStatus.BLOCKED;
  const message = mismatchResult.status !== MismatchStatus.OK ? mismatchResult.message : autoSwitchMessage;
  const color = isBlocked ? 'red' : 'yellow';
  const iconColor = isBlocked ? Color.RED_500 : Color.YELLOW_600;

  return (
    <Alert
      color={color}
      variant="light"
      mb="sm"
      icon={<BenchlingIcon icon={isBlocked ? 'exclamation' : 'warning'} color={iconColor} />}
      styles={{
        root: {borderLeft: `4px solid ${iconColor}`, flexShrink: 0},
        message: {color: Color.GRAY_900},
      }}
    >
      {message}
    </Alert>
  );
}
